import axios from 'axios';
import axiosMiddleware from 'redux-axios-middleware';
import { message, Modal } from 'antd';
import qs from 'query-string';

message.config({
  top: 100,
  duration: 3,
});

let isModalShownOnce = false;
localStorage.setItem('IS_NEED_OPEN_MODAL', 'need');

const reloadPage = () => {
  const clearTimeInter = setInterval(() => {
    const isNeedReload = localStorage.getItem('NEED_RELOAD_PAGE_INFOS');

    if (isNeedReload === 'need') {
      isModalShownOnce = false;
      localStorage.setItem('NEED_RELOAD_PAGE_INFOS', '');
      localStorage.setItem('IS_NEED_OPEN_MODAL', 'need');
      window.location.reload();
      clearInterval(clearTimeInter);
    }
  }, 1000);
};

reloadPage();

const axiosClient = axios.create({
  responseType: 'json',
  paramsSerializer: params => qs.stringify(params),
  withCredentials: true,
  timeout: 30000,
});

const checkVersion = (version) => {
  if (window.STATIC_PACKAGE_VERSION && Number(version) > Number(window.STATIC_PACKAGE_VERSION)) {
    const isNeedOpenModal = localStorage.getItem('IS_NEED_OPEN_MODAL');
    if (!isModalShownOnce && isNeedOpenModal === 'need') {
      isModalShownOnce = true;
      localStorage.setItem('IS_NEED_OPEN_MODAL', '');
      Modal.confirm({
        title: '版本强制更新提示',
        content: '系统已经更新，为了不影响你的正常工作，请及时刷新！',
        okText: '立即刷新',
        cancelText: '延迟五分钟',
        onOk: () => {
          localStorage.setItem('NEED_RELOAD_PAGE_INFOS', 'need');
        },
        onCancel: () => {
          localStorage.setItem('NEED_RELOAD_PAGE_INFOS', '');
          setTimeout(() => {
            isModalShownOnce = false;
            localStorage.setItem('IS_NEED_OPEN_MODAL', 'need');
          }, 5 * 60 * 1000);
        },
      });
    }
  }
};

const axiosOptions = {
  interceptors: {
    response: [{
      success: (object, response) => {
        const version = response.headers['X-Support-Web-Version'];
        checkVersion(version);
        if (response.data && response.data.meta) {
          switch (response.data.meta.code) {
            case 0:
              break;
            case 200:
              break;
            case 30001: // not logged in
              window.location.href = `/api/login?redirectUrl=${encodeURIComponent(window.location.href)}`;
              break;
            case 30006:
              window.location.href = '/login';
              break;
            case 40612:
              window.location.href = '/candidates';
              break;
            default:
              message.error(response.data.meta.message);
              if(! window.location.href.includes('/statistics')) {
                throw new Error(`${response.data.meta.code}: ${response.data.meta.message}`);
              }
          }
          return response.data;
        }
        // message.error('请求发生错误');
      },
    }],
  },
  onError: ({ error }) => {
    console.log(error, 'onError')
    message.error(error.message);
  },
};

export default axiosMiddleware(axiosClient, axiosOptions);